{
    "RangeCombo_Search_Placeholder": "Recherche...",
    "NAME": "RangeComboLanguage"
}